/*
 * @Author: your name
 * @Date: 2021-08-20 12:06:25
 * @LastEditTime: 2026-06-17 19:08:45
 * @LastEditors: qiuhc 2282747917@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \vue-element-ui-admin\src\utils\request.js
 */
import Axios from "axios";
import Config from "@/config/app";
import {
  Notification
  // Loading
} from "element-ui";
import { getToken, removeToken } from "../utils/common";

import router from "@/router";

const service = Axios.create({
  baseURL: Config.apiUrl + "/api" + Config.apiPrefix,
  headers: {
    Accept: "*/*"
  },
  timeout: Config.timeout
});
service.defaults.retry = Config.requestRetry;
service.defaults.retryDelay = Config.requestRetryDelay;

service.interceptors.request.use(
  config => {
    // if (!config.closeLoading) {
    //   window.loadingInstance = Loading.service();
    // }
    config.headers[Config.tokenKey] = getToken();
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  res => {
    console.log(res);
    // if (!res.config.closeLoading) {
    //   window.loadingInstance.close();
    // }
    if (res.status !== 200) {
      Notification({
        title: "数据返回出错",
        message: "请稍后重试",
        type: "warning"
      });
      return Promise.reject("error");
    } else {
      // if (res.config.closeInterceptors) {
      //   return res.data;
      // }
      if (res.data.code === 202 || res.data.code === 204) {
        removeToken(); //登陆失效执行
        Notification({
          title: res.data.msg,
          message: "请重新登录",
          type: "warning"
        });
        router.push("/login");
        return Promise.reject("error");
      }
      if (res.data.code === 500) {
        Notification({
          title: res.data.msg,
          message: "请修改重新提交",
          type: "warning"
        });
        return Promise.reject("error");
      }
      if (res.data.code === 510) {
        Notification({
          title: "数据返回为空",
          message: "请稍后重试",
          type: "warning"
        });
      }
      if (res.data.code === 201) {
        Notification({
          title: res.data.msg,
          message: "请重新提交",
          type: "warning"
        });
      }
      if (res.data.code === 206) {
        Notification({
          title: res.data.msg,
          message: "请联系管理员",
          type: "error"
        });
        return Promise.reject("error");
      }
      return res.data;
    }
  },
  error => {
    // window.loadingInstance.close();
    Notification({
      title: "请求未响应",
      message: "服务器可能出了点问题",
      type: "warning"
    });
    return Promise.reject(error); //不能去掉，否则请求超时会进入到then方法，导致逻辑错误。
  }
);

export default service;
